var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgE6(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_639",
    "data-name": "Group 639",
    xmlns: "http://www.w3.org/2000/svg",
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_45",
    "data-name": "Rectangle 45",
    transform: "translate(0)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 57,
    height: 57,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 56,
    height: 56,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "teacher",
    transform: "translate(3 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_332",
    "data-name": "Path 332",
    d: "M173,51.815l-.3,2.661-.2,1.792H147.408l-.2-1.792-.3-2.661a13.79,13.79,0,0,1,1.031-6.954,13.8,13.8,0,0,0,1.1-6.12l-.156-3.1a11.083,11.083,0,1,1,22.139,0l-.156,3.1a13.8,13.8,0,0,0,1.1,6.12A13.783,13.783,0,0,1,173,51.815Z",
    transform: "translate(-133.068 -24.004)",
    fill: "#8f4d2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_333",
    "data-name": "Path 333",
    d: "M255.074,51.81l-.3,2.661H244.72V44.612l1.792-3.585v-7.17a9.868,9.868,0,0,0-7.253-9.51A11.1,11.1,0,0,1,253.1,35.635l-.156,3.1a13.8,13.8,0,0,0,1.1,6.12A13.783,13.783,0,0,1,255.074,51.81Z",
    transform: "translate(-215.145 -23.999)",
    fill: "#82462a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_334",
    "data-name": "Path 334",
    d: "M219.113,223.17a1.254,1.254,0,0,1-1.255-1.255V216h-7.17v5.915a1.254,1.254,0,0,1-1.255,1.255H208v5.377h12.547V223.17Z",
    transform: "translate(-187.387 -194.491)",
    fill: "#fec9a3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_335",
    "data-name": "Path 335",
    d: "M236.125,220.481a4.917,4.917,0,0,0,3.044-1.1V216H232v3.382a4.917,4.917,0,0,0,3.044,1.1Z",
    transform: "translate(-208.698 -194.491)",
    fill: "#feb784"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_336",
    "data-name": "Path 336",
    d: "M208.132,85.377v4.481a8.066,8.066,0,1,1-16.132,0V85.377a12.159,12.159,0,0,0,4.134-4.683l.347-.695.509.425a22.377,22.377,0,0,0,11.142,4.953Z",
    transform: "translate(-173.179 -73.726)",
    fill: "#fec9a3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_337",
    "data-name": "Path 337",
    d: "M284.28,121.509v4.481a8.069,8.069,0,0,1-6.525,7.919,9.823,9.823,0,0,0,2.94-7.023v-6.2A22.352,22.352,0,0,0,284.28,121.509Z",
    transform: "translate(-249.328 -109.858)",
    fill: "#fec093"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_338",
    "data-name": "Path 338",
    d: "M217.344,138.689a1.344,1.344,0,1,1,1.344-1.344A1.344,1.344,0,0,1,217.344,138.689Z",
    transform: "translate(-194.491 -123.453)",
    fill: "#7a432a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_339",
    "data-name": "Path 339",
    d: "M289.344,138.689a1.344,1.344,0,1,1,1.344-1.344A1.344,1.344,0,0,1,289.344,138.689Z",
    transform: "translate(-258.425 -123.453)",
    fill: "#7a432a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_340",
    "data-name": "Path 340",
    d: "M242.689,178.689A2.692,2.692,0,0,1,240,176h1.792a.9.9,0,0,0,1.792,0h1.792A2.692,2.692,0,0,1,242.689,178.689Z",
    transform: "translate(-215.802 -158.972)",
    fill: "#f7a468"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_341",
    "data-name": "Path 341",
    d: "M224,312h8.962v6.274H224Z",
    transform: "translate(-201.595 -279.736)",
    fill: "#e0e0de"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_342",
    "data-name": "Path 342",
    d: "M118.813,303.265a2.72,2.72,0,0,1-3.021-1.8l-5.92-11.105a6.979,6.979,0,0,1-1.25,6.673v7.17H92.49v-7.17a6.991,6.991,0,0,1-1.237-6.756L85.237,301.46a2.719,2.719,0,1,1-5.163-1.707l6.581-16.38A5.376,5.376,0,0,1,91.644,280h3.534l5.377,9.858L105.933,280h3.521a5.382,5.382,0,0,1,5,3.391l6.505,16.362a2.721,2.721,0,0,1-2.143,3.512Z",
    transform: "translate(-73.669 -251.321)",
    fill: "#ec8c8c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_343",
    "data-name": "Path 343",
    d: "M74.159,392.4l.646-8.4h5.377v8.634a3.016,3.016,0,1,1-6.024-.231Z",
    transform: "translate(-68.532 -343.67)",
    fill: "#f59898"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_344",
    "data-name": "Path 344",
    d: "M32.382,266.885a1.743,1.743,0,0,0-1.137,2.471l.82,1.64H28.854a5.377,5.377,0,0,1-2.4-.568l-.893-.447a1.075,1.075,0,0,0-1.556.962v2.529a1.792,1.792,0,0,0,.991,1.6l1.459.729a5.377,5.377,0,0,0,2.4.568h6.8V271l-1.227-3.068A1.743,1.743,0,0,0,32.382,266.885Z",
    transform: "translate(-24 -239.629)",
    fill: "#fec9a3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_345",
    "data-name": "Path 345",
    d: "M80,352h5.377v3.585H80Z",
    transform: "translate(-73.726 -315.255)",
    fill: "#e0e0de"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_346",
    "data-name": "Path 346",
    d: "M220.658,307.03a2.72,2.72,0,0,1-3.021-1.8l-5.92-11.105a6.979,6.979,0,0,1-1.25,6.673v7.17H194.63c7.4-4.831,13.638-10.961,18.877-23.723a5.369,5.369,0,0,1,2.789,2.916l6.505,16.362a2.721,2.721,0,0,1-2.143,3.512Z",
    transform: "translate(-175.515 -255.086)",
    fill: "#e07f7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_347",
    "data-name": "Path 347",
    d: "M304.962,350.34,296,348.547V336l8.962,1.792Z",
    transform: "translate(-265.529 -301.047)",
    fill: "#a36548"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_348",
    "data-name": "Path 348",
    d: "M408,350.34l8.962-1.792V336L408,337.792Z",
    transform: "translate(-364.982 -301.047)",
    fill: "#8f4d2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_349",
    "data-name": "Path 349",
    d: "M376,352h3.585v12.547H376Z",
    transform: "translate(-336.566 -315.255)",
    fill: "#95573a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_350",
    "data-name": "Path 350",
    d: "M306.755,316.481a3.174,3.174,0,0,0-2.652-3.131L296,312v2.689l8.962,1.792h1.792a3.174,3.174,0,0,1,2.652-3.131l8.1-1.35v2.689l-8.962,1.792Z",
    transform: "translate(-265.529 -279.736)",
    fill: "#d4bd81"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_351",
    "data-name": "Path 351",
    d: "M436.628,421.294l-3.585.6a.9.9,0,0,1-1.044-.884v-3.331a1.167,1.167,0,0,1,.975-1.151l3.044-.507a1.167,1.167,0,0,1,1.359,1.151v3.241A.9.9,0,0,1,436.628,421.294Z",
    transform: "translate(-386.293 -372.087)",
    fill: "#fec9a3"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgE6);
export default __webpack_public_path__ + "static/media/e6.450ad57ed4143ad6464a3b659f26f02d.svg";
export { ForwardRef as ReactComponent };